import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
    ADD_NEW_LEGISLATION,
    DELETE_LEGISLATION,
    LEGISLATION_FORM_TOOGLE_LOADING,
    SET_LEGISLATION_LIST,
    SHOW_NOTIFICATION,
    UPDATE_LEGISLATION,
} from "../constants";
import { formatLegislations } from "./settingsActionsUtils";

/* LEGISLATION LIST */
export const fetchLegislations = () => {
    return async (dispatch) => {
        const response = await axios
            .get(API.legislations.list)
            .then((response) => {
                const legislations = formatLegislations(response.data);
                dispatch({
                    type: SET_LEGISLATION_LIST,
                    payload: keyBy(legislations, "_id"),
                });
                return response.status;
            })
            .catch((err) => err);
        return response;
    };
};

// LEGISLATIONS
export const createLegislation = (newLegislation) => {
    return async (dispatch) => {
        dispatch({ type: LEGISLATION_FORM_TOOGLE_LOADING });
        const response = await axios
            .post(API.legislations.create, newLegislation)
            .then((response) => {
                const legislation = formatLegislations(response.data);
                dispatch({ type: ADD_NEW_LEGISLATION, payload: legislation });
                dispatch({ type: LEGISLATION_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "success",
                        message: "Legislación creado con éxito.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: LEGISLATION_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const updateLegislation = (updatedLegislation) => {
    return async (dispatch) => {
        dispatch({ type: LEGISLATION_FORM_TOOGLE_LOADING });
        const response = await axios
            .put(`${API.legislations.edit}${updatedLegislation && updatedLegislation._id}`, updatedLegislation)
            .then((response) => {
                const legislation = formatLegislations(response.data);
                dispatch({ type: UPDATE_LEGISLATION, payload: legislation });
                dispatch({ type: LEGISLATION_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Legislación actualizado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: LEGISLATION_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const deleteLegislations = (Ids) => {
    return async (dispatch) => {
        dispatch({ type: LEGISLATION_FORM_TOOGLE_LOADING });
        const response = await axios
            .delete(`${API.legislations.delete}`, { data: Ids })
            .then((response) => {
                dispatch({ type: DELETE_LEGISLATION, payload: Ids });
                dispatch({ type: LEGISLATION_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Legislación eliminado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: LEGISLATION_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};
